import { ChartView, RechartDataObject } from '../../chart-kit/shared/utils/chartModel'
import { HistoryData } from '../models/systemDataStoreModel'
import { getCurrentDifference } from './chartFunctions'

/**
 * Function to calculate the difference between the current and previous meter reading (15min interval) of self production.
 * Self consumption is the difference between @Consumption and @NetOut and can be positive only (negative differences are thus ignored).
 *
 * @param historyData
 * @param indexCurrent
 * @returns
 */
export const addSelfProductionOfLastFifteenMinutes = (historyData: HistoryData[], indexCurrent: number): number => {
  const isCurrentOrPreviousUndefined = !historyData[indexCurrent] || !historyData[indexCurrent - 1]

  if (isCurrentOrPreviousUndefined) return 0

  const currentSelfProduction = historyData[indexCurrent]?.Consumption - historyData[indexCurrent]?.NetOut
  const previousSelfProduction = historyData[indexCurrent - 1]?.Consumption - historyData[indexCurrent - 1]?.NetOut

  return Math.max(0, getCurrentDifference(currentSelfProduction, previousSelfProduction) ?? 0)
}

/**
 * Sum's up the self production for the given data
 *
 * Note: The data object is quite large. Only for the time-frame relevant SelfProduction values have been added to the data object beforehand.
 * Because of that many data point will not contain any value for SelfProduction which is to be expected with the current implementation.
 *
 * @param data
 * @returns
 */
export const getSumOfSelfProduction = (data: RechartDataObject[] = [], view: ChartView): number => {
  const filteredData = data.filter(item => item.SelfProduction)
  const updatedData = view === 'day' || view === 'week' ? filteredData.slice(1, filteredData.length) : filteredData
  return updatedData.reduce((sum, item) => sum + ((item.SelfProduction as number) || 0), 0)
}
